import React from "react";
import { Popover } from "react-tiny-popover";
import cs from "classnames";
import "./styles.scss";

interface PopoverViewProps {
  isOpen: boolean;
  positions?: any;
  content?: any;
  containerClassName?: any;
  children?: any;
  parentElement?: any;
  [res: string]: any;
}

const PopoverView: React.FC<PopoverViewProps> = ({
  isOpen,
  children,
  positions = ["top", "bottom", "left", "right"],
  content,
  containerClassName,
  parentElement,
  ...res
}) => {
  return (
    <Popover
      isOpen={isOpen}
      content={content}
      containerClassName={cs("popover-wrapper-main", {
        [containerClassName]: containerClassName,
      })}
      parentElement={parentElement}
      {...res}
    >
      {children}
    </Popover>
  );
};
export default PopoverView;
